import { useToastify } from "../../library/toastify/toast-provider";
import { useProposalTypeData } from "../proposal/use-proposal-type-data";

export const useCoverageInputsValidation = () => {

    const { showToastNotify } = useToastify();
    const { 
        isLevelRanking, 
        isUniformCoverage, 
        isSalaryRank,
        inputsBySalaryRank,
        inputsByLevelRanking,
        inputsByUniformCoverage,
        // amountOfLoansFAmount,
    } = useProposalTypeData();

    const isValidCoverageInputs = () => {
        // const hasInvalidMultiplier = inputsBySalaryRank.some(r => r.multiplierValue < 12 || r.multiplierValue > 48);
        // const hasInvalidSalary = inputsBySalaryRank.some(r => !r.salary || r.salary <= 0);
        // const hasInvalidResult = inputsBySalaryRank.some(r => !r.result || r.result <= 0);
        // const hasInvalidDesignation = inputsBySalaryRank.some(r => !r.designation?.trim());
        // const hasInvalidLabel = inputsByLevelRanking.some(i => !i.label?.trim());
        // const hasInvalidFAmount = inputsByLevelRanking.some(i => !i.fAmount || i.fAmount <= 0);
        const hasInvalidFAmountUniformCoverage = !inputsByUniformCoverage?.fAmount || inputsByUniformCoverage?.fAmount <= 0;
        // const hasInvalidFAmountLoansAmount = !amountOfLoansFAmount || amountOfLoansFAmount <= 0

        if (isLevelRanking) {
            const invalidInput = inputsByLevelRanking.find(
                (input) => !input.label?.trim() || !input.fAmount || input.fAmount <= 0
            );

            if (invalidInput) {
                if (!invalidInput.label?.trim() && (!invalidInput.fAmount || invalidInput.fAmount <= 0)) {
                    showToastNotify("Please complete the designation and insurance coverage amount fields.", "warning");
                    return false;
                }

                if (!invalidInput.label?.trim()) {
                    showToastNotify("Please enter a designation.", "warning");
                    return false;
                }

                if (!invalidInput.fAmount || invalidInput.fAmount <= 0) {
                    showToastNotify(`Please enter a valid average salary for "${invalidInput.label || "the designation"}".`,"warning");
                    return false;
                }
            }
        }

        if(isUniformCoverage) {
            if (hasInvalidFAmountUniformCoverage) {
                showToastNotify("Uniform coverage amount must be greater than 0", "warning");
                return false;
            }
        }

        if (isSalaryRank) {
            const invalidRow = inputsBySalaryRank.find((row) =>
                !row.designation?.trim() ||
                !row.salary ||
                row.salary <= 0 ||
                row.multiplierValue < 12 ||
                row.multiplierValue > 48 ||
                !row.result ||
                row.result <= 0
            );

            if (invalidRow) {
                if (
                    !invalidRow.designation?.trim() &&
                    (!invalidRow.salary || invalidRow.salary <= 0)
                ) {
                    showToastNotify(
                        "Please complete the designation and average Salary fields.",
                        "warning"
                    );
                    return false;
                }

                if (!invalidRow.designation?.trim()) {
                    showToastNotify("Please enter a designation.", "warning");
                    return false;
                }

                if (!invalidRow.salary || invalidRow.salary <= 0) {
                    showToastNotify(
                        `Please enter a valid average salary for "${invalidRow.designation || "the designation"}".`,
                        "warning"
                    );
                    return false;
                }

                if (
                    invalidRow.multiplierValue < 12 ||
                    invalidRow.multiplierValue > 48
                ) {
                    showToastNotify(
                        `Salary multiplier for "${invalidRow.designation || "the designation"}" must be between 12 and 48.`,
                        "warning"
                    );
                    return false;
                }

                if (!invalidRow.result || invalidRow.result <= 0) {
                    showToastNotify(
                        `The computed result for "${invalidRow.designation || "the designation"}" must be greater than 0.`,
                        "warning"
                    );
                    return false;
                }
            }
        }

        // if(isAmountOfLoans !== null && hasInvalidFAmountLoansAmount) {
        //     showToastNotify("Loan amount must be greater than 0", "warning");
        //     return false;
        // }
        
        return true;
    };

    return { isValidCoverageInputs };
};